module.exports = {"title":"Welcome to Patna","date":"2017-05-09T20:30:00+05:30","path":"/2017-05-09-patna/","author":"HARRISON","body":"<p><img src=\"./diary.jpg\" alt=\"Image\"></p>\n<p>When we got to Patna, we went through a monsoon.</p>\n<p>The driver was crazy 'cause he couldn’t see where he was going. It was pretty frightening!</p>\n<p>We changed hotel because the first one was rubbish!</p>\n<p><img src=\"./snippet.jpg\" alt=\"Image\"></p>\n<p>=YOUTUBESTART=T1G3nv5BuIk=YOUTUBEEND=</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./2017-05-09-harrison/index.md
// module id = 1064
// module chunks = 0